import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Loading, TableLayout } from "../../components"
import moment from "moment"
import * as ApiHelper from "../../ApiHelper"
import { LoadModalWithLabel } from "./"
import { ToastContainer, ToastMessage } from "react-toastr"
import Util from "../../Util"
class ReciboForm extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.delete = this.delete.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.getReciboById = this.getReciboById.bind(this)
    this.onChangeRecibo = this.onChangeRecibo.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.state = {
      showLoad: false,
      showForm: false,
      initialRecibos: []
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  resetForm() {
    this.setState({
      nome: "",
      cpf: "",
      unidade: "",
      numeroContrato: "",
      nomeServidor: "",
      observacao: ""
    })
  }
  getReciboById(id) {
    return this.state.initialRecibos.filter(recibo => {
      return recibo.id === id
    })[0]
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  componentWillMount() {
    this.getRecibos()
  }
  onChangeRecibo(selectedItem) {
    var newValue = selectedItem.value
    this.setState({
      recibo: newValue,
      error: ""
    })
  }
  getRecibos() {
    ApiHelper.getRecibos((recibos, error) => {
      if (!error) {
        var recibosMapped = recibos.map(recibo => {
          const dateFormatted = moment(recibo.created_at).format("DD/MM/YYYY")
          const unidadeOrcamentaria =
            recibo.contrato.unidade_orcamentaria.uni_orc
          return {
            value: recibo.id,
            label: `${dateFormatted} - ${unidadeOrcamentaria}`
          }
        })
        recibosMapped.shift()
        this.setState({
          recibos: recibosMapped,
          initialRecibos: recibos,
          showForm: true
        })
      } else {
        console.log(error)
      }
    })
  }
  delete(id, index) {
    this.toggleLoadModal()
    ApiHelper.deleteReciboDeAtestoDeServicos(id, error => {
      this.toggleLoadModal()
      if (error) {
        this.addAlert("", "Ocorreram erros")
      } else {
        var oldRecibos = this.state.initialRecibos
        oldRecibos.splice(index, 1)
        this.setState({
          initialRecibos: oldRecibos
        })
      }
    })
  }
  sendForm(id) {
    const recibo = this.getReciboById(id)
    var parameters = {
      contrato_id: recibo.contrato.id,
      nome_funcionaria: recibo.funcionario,
      cpf_funcionaria: recibo.cpf,
      nome_servidor: recibo.nome_servidor,
      data_recibo: recibo.data_recibo,
      reimpressao: true,
      cpf_secretaria: recibo.cpf_servidor,
      observacoes:
        recibo.atividades === undefined || recibo.atividades === null
          ? undefined
          : recibo.atividades
    }
    this.toggleLoadModal()
    ApiHelper.getReciboDeAtestoDeServicos(parameters, (response, error) => {
      this.toggleLoadModal()
      if (error) {
        console.log(error)
      } else {
        var url = URL.createObjectURL(response)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Recibo de atesto de serviço.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        this.props.callBack()
      }
    })
  }
  render() {
    if (!this.state.showForm) {
      return <Loading />
    }
    var tableHeaders = [
      "CPF do funcionário(a)",
      "Funcionário(a)",
      "Data",
      "Unidade orcamentaria",
      "Contrato",
      "Ações"
    ]
    var buttons = []
    var additionalButtons = []
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModalWithLabel
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <TableLayout
          headerButtons={buttons}
          sizeClass=""
          additionalButtons={additionalButtons}
          backgroundColor="as-blue"
          title="Recibos de atesto de serviço"
          subtitle="Recibos anteriormente gerados"
        >
          <table style={{ marginTop: "20px" }} className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.state.initialRecibos.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">
                      {Util.getMaskedCPFCNPJ(row.cpf)}
                    </td>
                    <td className="col-md-3">{row.funcionario}</td>

                    <td className="col-md-2">
                      {moment(row.data_recibo).format("DD/MM/YYYY")}
                    </td>
                    <td className="col-md-2">
                      {row.contrato.unidade_orcamentaria.uni_orc}
                    </td>
                    <td className="col-md-2">{row.contrato.num_contrato}</td>
                    <td className="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Reimprimir recibo"
                        onClick={() => this.sendForm(row.id)}
                        className="btn btn-info btn-simple btn-xs"
                      >
                        <i className="material-icons">local_printshop</i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover recibo"
                        onClick={() => this.delete(row.id, key)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(ReciboForm)



// WEBPACK FOOTER //
// ./src/views/modais/ReciboForm.js